import { observer } from 'mobx-react';
import LearningCollectionEditStore from '../../../../Store';
import { ProductLicenseResource } from '../../../../../../Types';
import ModalStore from '../../../../../../../Modal/Store';
import { Maybe } from 'maybeasy';
import WarningModal from './WarningModal';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  store: LearningCollectionEditStore;
  modalStore: ModalStore;
  productLicense: Maybe<ProductLicenseResource>;
}

function ChangeProductLicenseWarningModal({ store, productLicense, modalStore }: Props) {
  return productLicense
    .map((productLicense) => (
      <WarningModal store={store} modalStore={modalStore} newProductLicense={productLicense} />
    ))
    .getOrElse(emptyFragment);
}

export default observer(ChangeProductLicenseWarningModal);
